// cSpell:enableCompoundWords
import useLobbyManager from 'hooks/useLobbyManager';
import React from 'react';
import styles from './GamesSection.module.scss';

type GamesSectionInfoPanelProps = {
  className?: string;
};

const GamesSectionInfoPanel: React.FC<GamesSectionInfoPanelProps> = ({ className = '' }) => {
  const baseCls = `${styles.SectionInfoPanel} ${className}`;

  const { playerName } = useLobbyManager();

  return (
    <div className={baseCls}>
      <span className={styles.SectionInfoPanelTitle}>Welcome the lobby {playerName}.</span>
      <span className={styles.SectionInfoPanelMessage}>⍟ Here is where you join, create, and resume games</span>
    </div>
  );
};

export default GamesSectionInfoPanel;
